$ ->
  share = Ya.share2 "share-button", 
    content:
      url: document.location

  # Следим за изменением URL страницы через AJAX-запросы
  $(stateMachine).on "change-title", ->
    share.updateContent
      url: location.href
      title: document.title